module.exports = "/static/assets/410ccbdf0bbd12597c7152f64d44afca.jpg";